import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Image, Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';



import i18n from 'I18n';

import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import { SectionTopTitle } from 'components/base/CommonComponent';
import { ReactHookFormMarkDown } from 'components/base/CustomMarkDownArea';
import {
  ReactHookFormErrorMessage,
  hasError,
} from 'components/base/ErrorFieldMessage';
import InputFieldControl from 'components/base/InputFieldControl';
import BasePrompt from 'components/base/prompt/BasePrompt';
import BrandSelectDropdown from 'components/campaign/campaignCreation/BrandSelectDropdown';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import ReactHookFormSwitch from 'components/reactHookFormComponents/ReactHookFormSwitch';
import ReactHookFormTitleWithRadio from 'components/reactHookFormComponents/ReactHookFormTitleWithRadio';
import StoreSelectDropdown from 'components/transactions/StoreSelectDropdown';
import {
  COUPON_MODES,
  COUPON_REDEMPTION_METHOD,
  COUPON_SET_MEDIUM,
  COUPON_SET_TYPES,
  COUPON_TYPES,
  CustomerSelectionBehavior,
  LanguageConfig,
  STORE_LOADING_TYPE,
} from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';

import { createAction } from 'utils';

import './CouponGeneral.scss';

const CREATE_NEW_TYPE = {
  brand: 'brand',
  store: 'store',
  none: 'none',
};

const mapPropsToState = (state) => ({
  brandStoreList: state.storeModel.brandStoreList || [],
  storeLoading: state.storeModel.allListLoading,
  originalBrandPK: state.createCoupon.couponTemplate?.selectedBrand?.pk,
});

const CouponGeneral = ({
  language,
  onFocus = () => {},
  brandStoreList = [],
  originalBrandPK,
}) => {
  const [refreshDate, setRefreshDate] = useState(new Date());
  const [createNewType, setCreateNewType] = useState(CREATE_NEW_TYPE.none);

  const dispatch = useDispatch();
  const params = useParams();
  const { id } = params;
  const createNewText =
    createNewType === CREATE_NEW_TYPE.brand ? 'brand' : 'store';
  const { watch, setValue, control, formState, clearErrors } = useFormContext();
  const { errors } = formState;

  const typeField = 'type';
  const watchType = watch(typeField);
  const watchMediumType = watch('mediumType');

  const offlineCouponSetTypeFieldName = 'offlineCouponSetType';
  const watchOfflineCouponSetType = watch(offlineCouponSetTypeFieldName);
  const offlineRedemptionMethodFieldName = 'offlineRedemptionMethod';
  const watchOfflineRedemptionMethod = watch(offlineRedemptionMethodFieldName);

  const watchSelectedBrand = watch('selectedBrand') || {};
  const ticketStoreFieldName = 'ticketStore';
  const watchTicketStore = watch(ticketStoreFieldName);
  const watchSelectedStores = watch('selectedStores') || [];
  const watchName = watch(`translations.${language}.name`);
  const shouldBeUsedInStoresFieldName = 'shouldBeUsedInStores';
  const watchshouldBeUsedInStores = watch(shouldBeUsedInStoresFieldName);
  // const customerStoreSelectionBehaviorFieldName =
  //   'customerStoreSelectionBehavior';
  // const watchCustomerStoreSelectionBehavior = watch(
  //   customerStoreSelectionBehaviorFieldName,
  // );
  // const customerOnlineOfflineSelectionBehaviorFieldName =
  //   'customerOnlineOfflineSelectionBehavior';
  // const watchCustomerOnlineOfflineSelectionBehavior = watch(
  //   customerOnlineOfflineSelectionBehaviorFieldName,
  // );
  // const couponModeFieldName = 'mode';
  // const watchCouponModeFieldName = watch(couponModeFieldName);

  const getRelatedStores = (keys) => {
    console.log('getRelatedStores: ', keys);
    dispatch({
      type: 'storeModel/doStoreRequest',
      payload: {
        ...keys,
        displayNameWithType:
          watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE,
      },
    });
  };

  const stopStoreLoading = () => {
    dispatch({
      type: 'storeModel/updateState',
      payload: { allListLoading: false },
    });
  };

  useEffect(() => {
    if (id && watchType === COUPON_TYPES.NORMAL) {
      dispatch(
        createAction('storeModel/getAllCouponStores')({
          couponTemplateId: id,
        }),
      );
    }
  }, [id]);

  useEffect(() => {
    console.log('watchSelectedBrand2:', watchSelectedBrand);
    if (!watchSelectedBrand.pk || watchSelectedBrand.pk === originalBrandPK) {
      return;
    }
    dispatch({
      type: 'storeModel/updateState',
      payload: { storeEditMode: true },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchSelectedBrand.pk]);

  useEffect(() => {
    if (watchSelectedBrand?.pk && watchType === COUPON_TYPES.TICKET) {
      dispatch(
        createAction('storeModel/getPagedStoreList')({
          brand: [watchSelectedBrand?.pk],
          isSimpleNode: true,
          isSelectorLoad: true,
          isOnlineStore: false,
          search: '',
          active: 'true',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchSelectedBrand.pk]);

  useEffect(() => {
    if (!watchshouldBeUsedInStores) {
      return;
    }
    if (!watchSelectedBrand.pk || language !== LanguageConfig.english) {
      return;
    }
    if (
      id &&
      !watchshouldBeUsedInStores &&
      watchSelectedBrand.pk === originalBrandPK
    ) {
      stopStoreLoading();
      return;
    }
    if (!id || watchSelectedBrand) {
      getRelatedStores({
        [STORE_LOADING_TYPE.BRAND]: watchSelectedBrand.pk,
        ...(watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
          ? {}
          : {
              isOnlineStore: watchMediumType === COUPON_SET_MEDIUM.ONLINE,
            }),
      });
      return;
    }
    if (!id) {
      return;
    }
    if (originalBrandPK && originalBrandPK !== watchSelectedBrand.pk) {
      return;
    }
    getRelatedStores({
      [STORE_LOADING_TYPE.COUPON]: id,
      notBrandRelate: true,
      ...(watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
        ? {}
        : {
            isOnlineStore: watchMediumType === COUPON_SET_MEDIUM.ONLINE,
          }),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchSelectedBrand.pk, watchshouldBeUsedInStores, refreshDate]);

  const brandSection = (
    <Controller
      control={control}
      name="selectedBrand"
      render={() => (
        <>
          <BrandSelectDropdown
            customClass={
              hasError(errors, 'selectedBrand') ? 'field-has-error' : ''
            }
            title={i18n.t('related_brand', {
              locale: language,
            })}
            defaultValue={{
              value: watchSelectedBrand,
              label: watchSelectedBrand?.name,
            }}
            onSelectChange={(item) => {
              onFocus('relatedBrand');
              if (item.value !== watchSelectedBrand) {
                setValue('selectedBrand', item.value, { shouldDirty: true });
                setValue('selectedStores', [], {
                  shouldDirty: true,
                });
                setValue(ticketStoreFieldName, null, { shouldDirty: true });
                clearErrors('selectedStores');
              }
            }}
            addButton={{
              title: 'Create Now',
              customClass: 'multiple-select-option-add btn-add-button-common',
              action: () => {
                setCreateNewType(CREATE_NEW_TYPE.brand);
              },
            }}
            editable={language === LanguageConfig.english}
            onFocus={() => onFocus('relatedBrand')}
            refreshDate={refreshDate}
          />
          {language === LanguageConfig.english ? (
            <ReactHookFormErrorMessage errors={errors} id="selectedBrand" />
          ) : null}
        </>
      )}
    />
  );

  // const CouponTypeStoreSelectorSection = (
  //   <>
  //     {language === LanguageConfig.english ? (
  //       <ReactHookFormSwitch
  //         title={i18n.t('using_in_specific_store', { locale: language })}
  //         tips={i18n.t('using_in_specific_store_tips', { locale: language })}
  //         valueFieldName={shouldBeUsedInStoresFieldName}
  //         extraActionOnChange={({ value }) => {
  //           if (!value) {
  //             setValue('selectedStores', null, {
  //               shouldDirty: true,
  //             });
  //           }
  //         }}
  //       />
  //     ) : (
  //       <>
  //         <CustomTitleLabel
  //           title={i18n.t('using_in_specific_store', { locale: language })}
  //         />
  //         <div className="tips-with-popover">
  //           <label className="tips-message">
  //             {i18n.t('using_in_specific_store_tips', { locale: language })}
  //           </label>
  //         </div>
  //         <div className="second-section-content">
  //           {i18n.t(watchshouldBeUsedInStores ? 'yes' : 'no', {
  //             locale: language,
  //           })}
  //         </div>
  //       </>
  //     )}
  //   </>
  // );

  // const StoreSection = () => (
  //   <div
  //     // hidden={watchSelectedBrand?.pk ? false : true}
  //     onFocus={() => onFocus('selectedStores')}
  //   >
  //     {watchType === COUPON_TYPES.NORMAL && CouponTypeStoreSelectorSection}
  //   </div>
  // );

  const showStoreName = (store) => {
    const extraName = store.visibleInFrontEnd ? '' : '(closed)';
    if (
      language !== LanguageConfig.english &&
      store.storeTranslations &&
      store.storeTranslations[language] &&
      store.storeTranslations[language].storeName
    ) {
      return `${store.storeTranslations[language].storeName}${extraName}`;
    }
    return `${store.storeName}${extraName}`;
  };
  // const selectionBehaviorView = () => {
  //   if (watchType === COUPON_TYPES.NORMAL && watchshouldBeUsedInStores) {
  //     if (language === LanguageConfig.english) {
  //       return (
  //         <div>
  //           <ReactHookFormTitleWithRadio
  //             title={'Store selection behavior on front end'}
  //             valueFieldName={customerStoreSelectionBehaviorFieldName}
  //             options={CustomerStoreSelectionOptions}
  //             disabled={false}
  //           />
  //           <ReactHookFormErrorMessage
  //             errors={errors}
  //             id={customerStoreSelectionBehaviorFieldName}
  //           />
  //         </div>
  //       );
  //     }
  //   }
  //   if (
  //     watchType === COUPON_TYPES.NORMAL &&
  //     !watchshouldBeUsedInStores &&
  //     watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
  //     //      && (
  //     //        watchOfflineCouponSetType === COUPON_SET_TYPES.SYSTEM_GENERATED ||
  //     //        watchOfflineRedemptionMethod !== COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE
  //     //      )
  //   ) {
  //     if (language === LanguageConfig.english) {
  //       return (
  //         <div>
  //           <ReactHookFormTitleWithRadio
  //             title={'Online or physical store selection on front end'}
  //             tips={
  //               'Since this coupon medium is "online or offline",  even if this coupon are not required to select applicable store (toggle off), the customer still need to select "online" or "offline".'
  //             }
  //             valueFieldName={customerOnlineOfflineSelectionBehaviorFieldName}
  //             options={CustomerOnlineOfflineSelectionOptions}
  //             disabled={false}
  //           />
  //           <ReactHookFormErrorMessage
  //             errors={errors}
  //             id={customerOnlineOfflineSelectionBehaviorFieldName}
  //           />
  //         </div>
  //       );
  //     }
  //   }
  //   return null;
  // };
  const selectStoreView = () => {
    if (
      watchType === COUPON_TYPES.NORMAL &&
      watchSelectedBrand?.pk &&
      watchshouldBeUsedInStores
    ) {
      if (language === LanguageConfig.english) {
        return (
          <div>
            <BaseMultipleSelectorV2
              title={i18n.t('applicable_stores', { locale: language })}
              size={['shorter']}
              onFocusFunc={() => {
                onFocus('selectedStores');
              }}
              namespace="storeModel"
              data={{
                sourceData: brandStoreList,
                targetData: watchSelectedStores,
                targetChange: (value) => {
                  setValue('selectedStores', value, {
                    shouldDirty: true,
                  });
                },
              }}
              addButton={{
                action: () => {
                  setCreateNewType(CREATE_NEW_TYPE.store);
                },
                title: 'Add store',
                requires: PermissionCodes.addStore,
                customClass: 'general-section-add-new btn-add-button-common',
              }}
              error={{
                error: hasError(errors, 'selectedStores'),
              }}
            />
            <ReactHookFormErrorMessage errors={errors} id="selectedStores" />
          </div>
        );
      }
      if (watchSelectedStores && watchSelectedStores?.length > 0) {
        return (
          <div>
            {watchSelectedStores.map((store) => {
              return (
                <div className="second-section-content" key={store.storeName}>
                  {showStoreName(store)}
                </div>
              );
            })}
          </div>
        );
      }
      return <></>;
    }
    if (watchType === COUPON_TYPES.TICKET && watchSelectedBrand?.pk) {
      if (language === LanguageConfig.english) {
        return (
          <>
            <StoreSelectDropdown
              title={i18n.t('using_in_one_single_store', { locale: language })}
              selectedStore={watchTicketStore}
              selectStore={(store) => {
                setValue(ticketStoreFieldName, store, { shouldDirty: true });
              }}
              hideAddButton={true}
              defaultFilter={{
                brand: [watchSelectedBrand?.pk],
                isSimpleNode: true,
                active: "true",
              }}
            />
            <ReactHookFormErrorMessage
              errors={errors}
              id={ticketStoreFieldName}
            />
          </>
        );
      }
      if (watchTicketStore?.pk) {
        return (
          <div
            className="second-section-content"
            key={watchTicketStore.storeName}
          >
            {showStoreName(watchTicketStore)}
          </div>
        );
      }
    }
  };

  return (
    <>
      <SectionTopTitle title={i18n.t('general', { locale: language })} />
      <InputFieldControl
        name={`translations.${language}.name`}
        title={i18n.t('name', { locale: language })}
        value={watchName}
        setValue={(value) => {
          setValue(`translations.${language}.name`, value, {
            shouldDirty: true,
          });
        }}
        onFocus={() => {
          onFocus('name');
        }}
      />
      <ReactHookFormMarkDown
        content={{
          label: i18n.t('short_description_optional', { locale: language }),
          error:
            language === LanguageConfig.english
              ? hasError(errors, `translations.${language}.shortDescription`)
              : false,
          key: `translations.${language}.shortDescription`,
          focus: () => {
            onFocus('shortDescription');
          },
        }}
      />
      <ReactHookFormErrorMessage
        errors={errors}
        id={`translations.${language}.shortDescription`}
      />
      {watchType === COUPON_TYPES.TICKET && brandSection}
      {/* <StoreSection /> */}
      {language !== LanguageConfig.english &&
      // ((watchType === COUPON_TYPES.NORMAL && watchshouldBeUsedInStores) ||
      //   watchType === COUPON_TYPES.TICKET) ? (
      watchType === COUPON_TYPES.TICKET ? (
        <CustomTitleLabel
          title={i18n.t('applicable_stores', { locale: language })}
        />
      ) : null}
      {/* {selectionBehaviorView()} */}
      {watchType === COUPON_TYPES.TICKET && selectStoreView()}

      <BasePrompt
        show={createNewType !== CREATE_NEW_TYPE.none}
        closeAction={() => {
          setCreateNewType(CREATE_NEW_TYPE.none);
        }}
        leftButton={{
          text: 'Done and refresh',
          action: () => {
            setRefreshDate(new Date());
            setCreateNewType(CREATE_NEW_TYPE.none);
          },
        }}
        rightButton={{
          text: `Go to create ${createNewText}`,
          action: () => {
            const pathname =
              createNewType === CREATE_NEW_TYPE.brand
                ? '/brands/create'
                : '/stores/create';
            window.open(pathname, '_blank');
          },
        }}
        title={`Go to create a ${createNewText}?`}
        description={`You will leave the coupon creation process. After you create a new ${createNewText}, you can back to this page.`}
      />
    </>
  );
};

export default connect(mapPropsToState)(CouponGeneral);